import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFarm = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.5 1C16.0448 1 14.894 1.44179 14.1054 2.23039C13.3244 3.01134 13 4.03196 13 5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5C15 4.46804 15.1756 3.98866 15.5196 3.64461C15.856 3.30821 16.4552 3 17.5 3C18.5448 3 19.144 3.30821 19.4804 3.64461C19.8244 3.98866 20 4.46804 20 5V15.5H18.375C17.8227 15.5 17.375 15.9477 17.375 16.5C17.375 17.0523 17.8227 17.5 18.375 17.5H21C21.5523 17.5 22 17.0518 22 16.4995V5C22 4.03196 21.6756 3.01134 20.8946 2.23039C20.106 1.44179 18.9552 1 17.5 1ZM21 16.5L22 16.4995C22 16.4996 22 16.5 21 16.5ZM9.40822 4.20133C9.04267 3.9259 8.53676 3.93381 8.18 4.22054L2.37355 8.88721C2.13738 9.07702 2 9.36367 2 9.66667V19C2 19.5523 2.44772 20 3 20H7C7.55228 20 8 19.5523 8 19V16H10V19C10 19.5523 10.4477 20 11 20H15C15.5523 20 16 19.5523 16 19V9.66667C16 9.35269 15.8525 9.05694 15.6018 8.868L9.40822 4.20133ZM4 10.1459L8.82627 6.26702L14 10.1653V18H12V15C12 14.4477 11.5523 14 11 14H7C6.44772 14 6 14.4477 6 15V18H4V10.1459Z",
		fill: "currentColor"
	})
});
export default SvgFarm;
